import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";

type MaterialThemeProps = {
    children: React.ReactNode;
};

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#B5D88A",
            dark: "#B5D88A",
        },
        text: {
            primary: "#0F2038",
        },
    },
    typography: {
        fontFamily: "Montserrat, sans-serif",
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});

const MaterialTheme: React.FC<MaterialThemeProps> = ({ children }) => {
    return (
        <div data-theme={muiTheme}>
            <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
        </div>
    );
};

export default MaterialTheme;
